import { createEventBus } from 'n8n-design-system/utils';

export const htmlEditorEventBus = createEventBus();
